export default {
  addresseeName: 'Janet Doe',
  address1: '1234 Main Street',
  address2: 'Apt 100',
  city: 'San Francisco',
  date: 'mm/dd/yyyy',
  email: 'jane.doe@example.com',
  firstname: 'Jane',
  fullname: 'Jane Doe',
  lastname: 'Doe',
  pharmacy: 'Walgreens',
  password: '••••••••',
  phone: '555 123 4567',
  relationship: 'Mother',
  state: 'California',
  zipcode: '94102',
};
